import { defineStore } from 'pinia';
import { ref } from 'vue';
import { LAWYER, COMPANY } from '@shared/constants/ProfileProductId';

export const useProfileProductId = defineStore('profileProductId', () => {
  const profileProductId = ref<typeof LAWYER | typeof COMPANY>(LAWYER);

  return { profileProductId };
});
